import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EventbusType } from '@movecloser/front-core';
import { Inject } from '@plugin/inversify';
/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let SidebarItem = class SidebarItem extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
    get hasChildren() {
        return !!this.item.children && this.item.children.length;
    }
    onClick() {
        this.eventBus.emit('ui:sidebar.close');
    }
    parentChanged(parentOpen) {
        if (!parentOpen) {
            this.isOpen = false;
        }
    }
    toggle() {
        this.isOpen = !this.isOpen;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], SidebarItem.prototype, "item", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], SidebarItem.prototype, "parentOpen", void 0);
__decorate([
    Inject(EventbusType)
], SidebarItem.prototype, "eventBus", void 0);
__decorate([
    Watch('parentOpen')
], SidebarItem.prototype, "parentChanged", null);
SidebarItem = __decorate([
    Component({
        name: 'SidebarItem',
        components: {
            SidebarNav: () => import('../SidebarNav/SidebarNav.vue')
        }
    })
], SidebarItem);
export { SidebarItem };
export default SidebarItem;
